<template>
    <Page class="cloud">

        <div v-if="$vuetify.breakpoint.xsOnly" class="mt-10">
            <h1 class="mt-0">Coroot Cloud</h1>

            <SignupForm/>

            <v-row v-for="v in features" class="value">
                <v-col class="flex-grow-0">
                    <div style="width: 40px">
                        <GreenArrow />
                    </div>
                </v-col>
                <v-col class="flex-grow-1">
                    <p class="header">{{v.header}}</p>
                    <p class="message">{{v.body}}</p>
                </v-col>
            </v-row>

        </div>

        <v-row v-else class="mt-10">
            <v-col>
                <h1 class="mt-0">Coroot Cloud</h1>

                <v-row v-for="v in features" class="value">
                    <v-col class="flex-grow-0">
                        <div style="width: 40px">
                            <GreenArrow />
                        </div>
                    </v-col>
                    <v-col class="flex-grow-1">
                        <p class="header">{{v.header}}</p>
                        <p class="message" v-html="v.body" />
                    </v-col>
                </v-row>

            </v-col>
            <v-col>
                <v-card class="px-6 mt-16">
                    <SignupForm/>
                </v-card>
            </v-col>
        </v-row>







    </Page>
</template>

<script>
import Page from "@/pages/Page";
import GreenArrow from "@/components/GreenArrow.vue";
import SignupForm from "@/components/SignupForm.vue";

export default {
    components: {SignupForm, Page, GreenArrow},
    computed: {
        features() {
            return [
                {
                    header: 'Worry-free operations',
                    body: 'Fully managed by Coroot team',
                },
                {
                    header: 'High Availability',
                    body: 'Coroot Cloud is replicated across multiple cloud providers and regions',
                },
                {
                    header: 'AI-powered root cause analysis',
                    body: 'Explain any anomalies in seconds',
                },
                {
                    header: "Try it for free for 14 days",
                    body: "No credit card required",
                },
                {
                    header: 'Predictable pricing',
                    body: 'Billed per node with no hidden costs (hourly billing)',
                },
                {
                    header: 'Enterprise ready',
                    body: 'SSO, RBAC, Audit Logs',
                },
            ]
        },
    },
}
</script>

<style scoped>
.cloud {
    font-family: Poppins, sans-serif;
}

.value .header {
    min-height: 32px;
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    flex-grow: 1;
    margin-bottom: 12px;
}
.value .message {
    font-size: 16px;
}
</style>
